import axios from "axios"
import { Apis } from "constants/apis"
import { SigninService } from "types/services"

const signin: SigninService = async(payload) => {
    const { data } = await axios.post(Apis.SIGNIN, payload)
    return data
}

export default signin